import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SerialEventsCount } from '../models/serialEventsCount.model';

@Injectable({
  providedIn: 'root',
})
export class SerialEventsCountService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  public getSerialEventsCount(userId: number): Observable<SerialEventsCount[]> {
    return this.http.get<SerialEventsCount[]>(
      `${this.apiServerUrl}/api/v1/getSerialEventsCount/${userId}`
    );
  }
  public runSerialEventsCount(userId: number): Observable<SerialEventsCount[]> {
    return this.http.get<SerialEventsCount[]>(
      `${this.apiServerUrl}/api/v1/runSerialEventsCount/${userId}`
    );
  }
}
